import React, { Component } from "react";
import PropTypes from "prop-types";
import { graphql } from "react-apollo";
import { queryGetCustomerFieldType } from "Apollo";
import Picker from "module-common/Picker";

export default graphql(queryGetCustomerFieldType)(
  class PickerField extends Component {
    static propTypes = { onSelected: PropTypes.func };
    render() {
      const data = this.props.data;
      const fields = data.getCustomerFieldType;
      const options = [];
      if (fields) {
        fields.forEach(field => {
          options.push({
            label: field.displayName,
            value: field
          });
        });
      }
      return (
        <Picker {...this.props} options={options}>
          {this.props.children}
        </Picker>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/module-case-management/info-panel/customer-field/PickerFieldWithQuery.js